import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { EnumHelperText, HelperText, Label } from 'shared/ui'
import type { ChatbotErrors, IParamsEnhancePrompt } from 'entities/Chatbot'
import { MessageField, type MessageFieldStore } from 'widgets/MessageField'
import { useChatbotContext } from 'pages/chatbot/context'
import styles from './styles.module.scss'

type IPointQualifyInstructionsProps = {
  errors: ChatbotErrors
  settings: {
    instructions: string
    setInstruction: (value: string, removeError: () => void) => void
  }
  getEnhancePromptData: (prompt: string, agentId: number) => IParamsEnhancePrompt
  id: number | null
  messageFieldStore: MessageFieldStore
}

export const PointQualifyInstructionsContent = observer((props: IPointQualifyInstructionsProps) => {
  const instructionsError = props.errors.getError('settings.qualify_instruction.value') ?? ''

  useEffect(() => {
    if (instructionsError) props.messageFieldStore.setHighlight('error')
  }, [instructionsError])

  return (
    <>
      <Label
        marginTop={24}
        marginBottom={1}
        label={{
          text: 'Qualification instructions',
          rightNode: (
            <>
              {/* Will be returned back after implement on backend side (The ticket does not currently exist) */}
              {/* {*/}
              {/*  <Button*/}
              {/*    text={isLoading ? 'Enhancing...' : 'Enhance'}*/}
              {/*    typeBtn='link'*/}
              {/*    contained='primary'*/}
              {/*    onClick={handleEnhancePrompt}*/}
              {/*    disabled={isLoading}*/}
              {/*    icon={'stars'}*/}
              {/*    size='small'*/}
              {/*  />*/}
              {/* }*/}
            </>
          ),
        }}
        questionTooltipProps={{
          label: 'Write instructions for the Agent to evaluate contacts',
          desc: 'Use merge fields to access contact data',
          type: 'description',
          sx: {
            ['& .MuiTooltip-tooltip > div > div:first-of-type']: {
              whiteSpace: 'nowrap',
            },
          },
        }}
      />
      <MessageField messageFieldStore={props.messageFieldStore} />

      {instructionsError && (
        <div className={styles.error}>
          <HelperText
            icon={'alertTriangleSmall'}
            variant={EnumHelperText.Error}
            text={instructionsError}
          />
        </div>
      )}
    </>
  )
})

export const PointQualifyInstructions = observer(() => {
  const {
    errors,
    model: { settings, getEnhancePromptData },
    id,
    stepQualifyStore: { messageFieldStore },
  } = useChatbotContext()

  return (
    <PointQualifyInstructionsContent
      errors={errors}
      settings={{
        instructions: settings.qualifyInstruction,
        setInstruction: (value: string, removeError: () => void) => {
          settings.setQualifyInstruction(value, removeError)
        },
      }}
      getEnhancePromptData={getEnhancePromptData}
      id={id}
      messageFieldStore={messageFieldStore}
    />
  )
})
